import React from "react";
import { TranslationsMap } from "../../pages/CountryPage/CountryPage";
import Logo, { LogoType } from "../Logo/Logo";
import AppDownload from "../AppDownload/AppDownload";

interface DownloadTileProps {
  translations: TranslationsMap;
}

const DownloadTile: React.FC<DownloadTileProps> = ({ translations }) => {
  return (
    <div>
      <div className="medium-layout ml-auto mr-auto">
        <div className="flex flex-col justify-center items-center w-full text-center">
          <div className="logo-container">
            <Logo type={LogoType.LogoOnly} />
          </div>
          <h1 className="mt-6 mb-2">
            {translations["landingPage.download.title"]}
          </h1>
          <p className="grey mb-6">
            {translations["landingPage.download.body"]}
          </p>
          <AppDownload center={true} />
        </div>
      </div>
    </div>
  );
};

export default DownloadTile;
